import env from "@beam-australia/react-env";

export const REACT_APP_API_HOST = env("API_HOST");
export const REACT_APP_API_HOST_GLOBAL = env("API_HOST_GLOBAL");
export const REACT_APP_API_HOST_SUPER_ADMIN = env("API_HOST_SUPER_ADMIN");
export const REACT_APP_AUTHENTICATION_API = env("AUTHENTICATION_API");
